module.exports = __webpack_public_path__ + "img/background.8b0f5dc5.svg";